var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.$t("overview.events.confirmation.header")))]),_c('vca-row',[_c('div',{staticClass:"clickable",on:{"click":function($event){return _vm.navigate('created')}}},[_vm._v(" "+_vm._s(_vm.$t("overview.events.created"))+" ")]),_c('div',{staticClass:"bold"},[_vm._v(_vm._s(_vm.confirmationDraft))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }